<template>
    <div class="page autorizacao-notas">
        <div class="row">
            <div class="sm-12">
                <div class="title">
                    <h2>Autorização de Notas</h2>
                </div>
            </div>
        </div>
        <div class="row" v-if="loading">
            <div class="sm-12">
                <p class="text-center"><i class="mdi mdi-spin mdi-loading mdi-48px"></i></p>
            </div>
        </div>
        <div class="row" v-else-if="notas.length == 0">
            <div class="sm-12">
                <p class="text-center">Nenhuma nota encontrada.</p>
            </div>
        </div>
        <div class="row" v-else>
            <div class="sm-12">
                <div class="responsive-table">
                    <table class="default-table">
                        <thead>
                            <tr>
                                <th align="left">Fornecedor</th>
                                <th align="left">Servico</th>
                                <th>Valor</th>
                                <th>Vencimento</th>
                                <th>Nota Fiscal</th>
                                <th>Autorização</th>
                            </tr>
                        </thead>
                        <tbody>
                            <Nota v-for="nota in notas" :key="nota.id" :nota="nota" @success="loadData"></Nota>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '/plugins/api';
import Nota from './autorizacao-notas/nota.vue';
export default {
    components: {
        Nota
    },
    data() {
        return {
            loading: false,
            errors: [],
            notas: []
        }
    },
    computed: {
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        },
        relacao() {
            return this.$store.getters.relacao;
        },
        tipo_relacao() {
            if (!this.relacao) {
                return null;
            }
            return this.relacao.tipoRelacao;
        },
        
    },
    methods: {
        async loadNotas() {
            try {
                this.notas = [];

                let { data: notas } = await api.get(`condominios/${this.codigo_condominio}/autorizacao-notas/${this.tipo_relacao}/pendentes`);
                this.notas = notas;
                
            } catch (err) {
                console.error(err);
                this.errors = [...this.errors, err];
            }
        },
        async loadData() {
            this.loading = true;
            this.errors = [];
            await this.loadNotas();
            this.loading = false;
        }
    },
    watch: {
        codigo_condominio: {
            immediate: true,
            handler() {
                this.loadData();
            }
        }
    }
}
</script>
<style lang="less">
@import "../../css/colors.less";


@media (max-width: 539px) {
    .page.autorizacao-notas {
        .default-table {
        thead {
            display: none;
        }
    
        tbody, tr, td {
            display: block;
            width: 100%;
            box-sizing: border-box;
        }
    
        tr {
            margin-bottom: 10px;
            padding-bottom: 10px; 
        }
    
        td {
            text-align: left;
            border:0;
        }
    
        td:before {
            content: attr(data-th) ": ";
            font-weight: bold;
            display: inline-block;
            width: 35%;
            box-sizing: border-box;
        }
        }
    }
}
</style>



